import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { isNilOrEmptyString } from 'ramda-extension';

export const HalfDoughnutLegend = ({ data = [] }) => {
	const cleanData = data.filter((item) => !isNilOrEmptyString(item));
	return (
		<Stack
			direction="row"
			sx={{
				my: 1,
				justifyContent: 'space-around',
			}}
		>
			{cleanData &&
				cleanData.map((item, i) => (
					<Typography
						className={item.name}
						key={i}
						variant="caption"
						sx={{
							fontWeight: 'bold',
						}}
					>{`${item.amount} / ${item.percentage} %`}</Typography>
				))}
		</Stack>
	);
};

HalfDoughnutLegend.propTypes = {
	data: PropTypes.array,
};

export default HalfDoughnutLegend;
